
import React, { useState } from 'react';
import Modal from '../ui/Modal';
import { Department } from '../../types';
import { Icons } from '../ui/Icons';

interface PrintOptionsModalProps {
    departments: Department[];
    onClose: () => void;
    onPrint: (departmentId: string) => void;
}

const PrintOptionsModal: React.FC<PrintOptionsModalProps> = ({ departments, onClose, onPrint }) => {
    const [selectedDepartmentId, setSelectedDepartmentId] = useState<string>('all');

    return (
        <Modal title="Print Options" onClose={onClose}>
            <div className="p-6 space-y-6">
                <div className="space-y-4">
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                        Select which department you would like to print the schedule for.
                    </p>
                    
                    <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                            Department
                        </label>
                        <select
                            value={selectedDepartmentId}
                            onChange={(e) => setSelectedDepartmentId(e.target.value)}
                            className="block w-full border border-gray-300 dark:border-slate-600 dark:bg-slate-700 dark:text-gray-200 rounded-lg shadow-sm py-2.5 px-4 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
                        >
                            <option value="all">All Departments</option>
                            {departments.map(dep => (
                                <option key={dep.id} value={dep.id}>{dep.name}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="flex justify-end gap-3 pt-4 border-t border-gray-100 dark:border-slate-700">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 transition-all"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => onPrint(selectedDepartmentId)}
                        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-all shadow-sm active:scale-95"
                    >
                        <Icons.Printer className="w-4 h-4" />
                        Print Schedule
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default PrintOptionsModal;
